import { render, staticRenderFns } from "./BackupAutomaticSwitcher.vue?vue&type=template&id=ccf98382&scoped=true"
import script from "./BackupAutomaticSwitcher.vue?vue&type=script&lang=js"
export * from "./BackupAutomaticSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BackupAutomaticSwitcher.vue?vue&type=style&index=0&id=ccf98382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf98382",
  null
  
)

export default component.exports